

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M6.78004 12.5994C6.6362 12.761 6.43525 12.8604 6.21955 12.8767C5.76068 12.8753 5.38902 12.5036 5.38766 12.0448L5.38764 2.02671C5.40293 1.56615 5.78866 1.20518 6.24922 1.22047C6.6657 1.2343 7.00813 1.55327 7.05142 1.96773L7.05142 12.0448C7.0352 12.2576 6.93809 12.456 6.78004 12.5994Z","fill":"#594A66"}, []), "\n", h('path', {"d":"M11.7832 7.5961C11.6278 7.75021 11.418 7.83712 11.1991 7.83801L1.18105 7.838C0.721638 7.80244 0.377998 7.40118 0.413534 6.94174C0.445262 6.53169 0.771027 6.20593 1.18106 6.17422L11.2286 6.14472C11.6892 6.12955 12.0748 6.49061 12.09 6.95118C12.0906 6.9695 12.0906 6.9878 12.09 7.00612C12.0739 7.23678 11.9628 7.45042 11.7832 7.5961Z","fill":"#594A66"}, []), "\n"]);
};

        